<template>
  <div class="zoom" :class="getSize" >
    <div @click="handleZoomClick({},1)" class="zoom-start" :class="currentZoom == 1 ? 'invisible':''"><span>1x</span></div>
      <div class="zoom-point" :class="i%10 == 0 || i ==1 ? 'big':''" :dataId="i" v-for="i in point" :key="i">
        <div class="zoom-point-inner" v-show="isPointInnerShow(i)">{{ currentZoom }}x</div>
      </div>
    <div @click="handleZoomClick({},zoomsize)" class="zoom-end" :class="currentZoom == zoomsize ? 'invisible':''"><span>{{ zoomsize }}x</span></div>
    <div class="zoom-line" ref="zoomDiv" @click="handleZoomClick" @mousedown="startDrag" @mousemove="onDrag" @mouseup="endDrag" @mouseleave="endDrag"></div>
  </div>
</template>

<script>
export default {
  name: 'zoomBtn',
  props: {
    zoomsize:Number,
    point: Number,
    initzoom: Number,
    factor:Number,
    boxsize: String
  },
  data() {
    return {
      currentZoom:0,
      currentIndex:0,
      diff:0,
      isDragging:false
    }
  },
  computed: {
    isPointInnerShow(){
      return (i) => {
        return this.currentIndex == i && this.currentZoom != 1 && this.currentZoom != this.zoomsize
      }
    },
    getSize(){
      return  this.boxsize == 'small' ? 'small' : ''
    }
  },
  mounted() {

  },
  updated() {
    
  },
  methods: {
    handleZoomClick(event,setIndex) {
      let div = this.$refs.zoomDiv;
      let rect = div.getBoundingClientRect();
      let clickX = event.clientX - rect.left; // 点击位置的 X 坐标
      let index = this.zoomsize > 10 ? (clickX / rect.width * (this.zoomsize-1) + 1).toFixed(0) : (clickX / rect.width * (this.zoomsize-1) + 1).toFixed(1);
      if(setIndex){
        index = setIndex
      }
      
      if(index <= 1){
        this.currentZoom = 1;
        this.currentIndex = 1
      }else if(index >= this.zoomsize){
        this.currentZoom = this.zoomsize;
        this.currentIndex = this.point;
      }else{
        this.currentZoom = index;
        this.currentIndex = (index - this.diff) * this.factor
      }
      this.currentIndex = parseInt(this.currentIndex)
      
      this.$emit('setzoom', this.currentZoom)
    },
    startDrag(event) {
      this.isDragging = true;
      this.updateZoomByPosition(event);
    },
    onDrag(event) {
      if (!this.isDragging) return;
      this.updateZoomByPosition(event);
    },
    endDrag() {
      if (!this.isDragging) return;
      this.isDragging = false;
    },
    
    updateZoomByPosition(event) {
      let div = this.$refs.zoomDiv;
      let rect = div.getBoundingClientRect();
      let clickX = event.clientX - rect.left;
      
      // Ensure clickX is within bounds
      clickX = Math.max(0, Math.min(clickX, rect.width));
      
      let index = this.zoomsize > 10 ? (clickX / rect.width * (this.zoomsize-1) + 1).toFixed(0) : (clickX / rect.width * (this.zoomsize-1) + 1).toFixed(1);
      
      if(index <= 1){
        this.currentZoom = 1;
        this.currentIndex = 1
      }else if(index >= this.zoomsize){
        this.currentZoom = this.zoomsize;
        this.currentIndex = this.point;
      }else{
        this.currentZoom = index;
        this.currentIndex = (index - this.diff) * this.factor
      }
      this.currentIndex = parseInt(this.currentIndex)
      if (!this.isDragging){
        this.$emit('setzoom', this.currentZoom)
      }
    }
  },
  created() {
    this.currentZoom = this.initzoom;
    if(this.factor == 10 || this.zoomsize == 2){
      this.diff = 1;
    }
    this.currentIndex = (this.initzoom-this.diff) * this.factor
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "sass:math";

@function px2vh($px) {
  @return math.div(100px * $px, 1080px) * 1vh;
}
.zoom{
  position: relative;
  height: px2vh(56);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 px2vh(10);
  .zoom-line{
    position: absolute;
    height: 100%;
    left: px2vh(25);
    width: calc(100% - px2vh(50));
    top: 0;
    cursor: pointer;
    z-index: 11;
  }
  .zoom-start,.zoom-end{
    font-family: PingFangSC-Semibold;
    font-size: px2vh(11);
    color: #FFFFFF;
    text-shadow: 0 0 px2vh(2) #000000;
    position: relative;
    cursor: pointer;
    span{
      z-index: 2;
      position: relative;
    }
    &.invisible{ 
      visibility: visible;
      &::before{
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        width: px2vh(32);
        height: px2vh(32);
        transform: translate3d(-50%, -50%, 0);
        border: 2px solid rgba(255,255,255,0.30);
        border-radius: 100%;
        z-index: 1;
        background: #222;
      }
    }
  }
  .zoom-start{
    margin-right: px2vh(5);
  }
  .zoom-end{
    margin-left: px2vh(5);
  }
  .zoom-point{
      background: #FFFFFF;
      box-shadow: 0 0 px2vh(2) 0 #000000;
      width: 2px;
      height: 2px;
      border-radius: 100%;
      position: relative;
      margin: 0 px2vh(2.5);
      
      &.big{
        width: 4px;
        height: 4px;
      }
      .zoom-point-inner{
        font-family: PingFangSC-Semibold;
        position: absolute;
        left: 50%;
        top: 50%;
        width: px2vh(32);
        height: px2vh(32);
        transform: translate3d(-50%, -50%, 0);
        font-size: px2vh(11);
        line-height: px2vh(32);
        text-align: center;
        color: #fff;
        border: 2px solid rgba(255,255,255,0.30);
        border-radius: 100%;
        background: #222;
        z-index: 10;
        cursor: pointer;
      }
  }
  &.small{
    height: px2vh(50);
    padding: 0 px2vh(8.34);
    .zoom-line{
      left: px2vh(22);
      width: calc(100% - px2vh(44));
    }
    .zoom-start{
      margin-right: px2vh(3.8);
    }
    .zoom-end{
      margin-left: px2vh(3.8);
    }
    .zoom-point{
      width: 1px;
      height: 1px;
      border-radius:50%;
      position: relative;
      margin: 0 px2vh(2.2);
      
      &.big{
        width: 3px;
        height: 3px;
      }
      .zoom-point-inner{
        width: px2vh(28.57);
        height: px2vh(28.57);
        line-height: px2vh(28.57);
      }
    }
  }
}

</style>